var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrowns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6901 3.26186L5.00146 0.376008C4.74679 0.246629 4.439 0.390989 4.37499 0.670177L2.96271 6.88994L0.371027 7.29578C0.0155727 7.35162 -0.124702 7.78743 0.129972 8.04074L4.61604 12.49L9.28052 10.3001L13.945 8.11019L13.3866 1.81689C13.3553 1.45871 12.929 1.28848 12.6594 1.52681L10.6914 3.26186H10.6901Z",
    fill: "#F9C600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 10.8089L4.61607 12.4894L9.28055 10.2995L13.945 8.1096L13.8429 6.96289C10.9788 8.97985 7.1165 10.9137 2.92188 10.8089Z",
    fill: "#F9C600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0352 7.87241L4.40719 12.3928C4.14779 12.5146 4.03623 12.8236 4.15802 13.083L4.21416 13.2026C4.33595 13.462 4.64497 13.5735 4.90437 13.4517L14.5324 8.93137C14.7918 8.80958 14.9034 8.50057 14.7816 8.24116L14.7254 8.12158C14.6036 7.86218 14.2946 7.75062 14.0352 7.87241Z",
    fill: "#F9C600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30929 7.86031C9.5902 7.08049 9.18747 6.22122 8.40977 5.94107C7.63208 5.66093 6.77391 6.066 6.493 6.84582C6.21209 7.62564 6.61482 8.48491 7.39252 8.76505C8.17022 9.0452 9.02839 8.64013 9.30929 7.86031Z",
    fill: "#FF005C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78657 6.80335C9.13249 7.38352 8.86283 8.12847 8.22683 8.35318C7.75561 8.51933 7.22039 8.32731 6.96435 7.89831C6.61843 7.31814 6.88809 6.57319 7.52409 6.34848C7.99531 6.18233 8.53053 6.37435 8.78657 6.80335Z",
    fill: "#FF005C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowns);
export default __webpack_public_path__ + "static/media/crowns.5ff379acfb712e751c55edd96162def7.svg";
export { ForwardRef as ReactComponent };